const DEFAULT_IDLE_MS = 5 * 60 * 1000
const DEFAULT_AWAY_MS = 30 * 60 * 1000
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click']

/**
 * 双超时空闲计时：
 * - 本页可见且无操作 → timeoutMs 后登出（默认 5 分钟）
 * - 切到其他标签/外站 → 使用更长的 awayTimeoutMs（默认 30 分钟）
 *   无法 100% 区分「逛外站」和「人离开」，用更长离开时限折中
 */
export function createIdleTimer({
  timeoutMs = DEFAULT_IDLE_MS,
  awayTimeoutMs = DEFAULT_AWAY_MS,
  onIdle,
} = {}) {
  let timer = null
  let active = false
  let hiddenAt = 0

  function clearTimer() {
    clearTimeout(timer)
    timer = null
  }

  function fireIdle(reason) {
    clearTimer()
    onIdle?.(reason)
  }

  function armVisible() {
    clearTimer()
    if (!active || document.hidden) return
    timer = setTimeout(() => {
      fireIdle('idle')
    }, timeoutMs)
  }

  function armAway() {
    clearTimer()
    if (!active || !document.hidden) return
    const elapsed = hiddenAt ? Date.now() - hiddenAt : 0
    const remain = Math.max(0, awayTimeoutMs - elapsed)
    timer = setTimeout(() => {
      fireIdle('away')
    }, remain)
  }

  function reset() {
    if (!active || document.hidden) return
    armVisible()
  }

  function onVisibilityChange() {
    if (!active) return
    if (document.hidden) {
      hiddenAt = Date.now()
      armAway()
      return
    }
    const awayMs = hiddenAt ? Date.now() - hiddenAt : 0
    hiddenAt = 0
    if (awayMs >= awayTimeoutMs) {
      fireIdle('away')
      return
    }
    armVisible()
  }

  function start() {
    if (active) return
    active = true
    hiddenAt = document.hidden ? Date.now() : 0
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, reset, { passive: true })
    })
    document.addEventListener('visibilitychange', onVisibilityChange)
    if (document.hidden) armAway()
    else armVisible()
  }

  function stop() {
    active = false
    hiddenAt = 0
    clearTimer()
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.removeEventListener(eventName, reset)
    })
    document.removeEventListener('visibilitychange', onVisibilityChange)
  }

  return { start, stop, reset }
}

export { DEFAULT_IDLE_MS, DEFAULT_AWAY_MS }
